export default {
  "LanguageSwitch.Locale": "言語",
}
